// src/pages/AdminPage/AdminPage.js
import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebase/config';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

const AdminPage = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    // Hide TARS chatbot on carnival admin pages
    useEffect(() => {
        const tarsWidget = document.querySelector('[id*="tars"]') ||
                          document.querySelector('[class*="tars"]') ||
                          document.querySelector('iframe[src*="tars"]');
        if (tarsWidget) {
            tarsWidget.style.display = 'none';
        }

        return () => {
            // Re-show on unmount if it exists
            if (tarsWidget) {
                tarsWidget.style.display = '';
            }
        };
    }, []);

    if (loading) {
        return (
            <div className="admin-loading">
                <div className="spinner-large"></div>
            </div>
        );
    }

    return user ? <AdminDashboard /> : <AdminLogin onLoginSuccess={() => setUser(auth.currentUser)} />;
};

export default AdminPage;
